import React, { useEffect, useState } from 'react';
import { AiSpinner, Flex, Stack, Text, Button, Card, CardContent, Token, } from '@stepstone-genesis/components';
import labels from 'modules/hub/components/AMAChat/constants/labels/ama';
import { trackEvent } from 'client/utils/tracking-global';
const DISLIKE_REASON_TRACKING = {
    1: 'doesntMakeSense',
    2: 'inappropriate',
    3: 'doesntAnswerTheQuestion',
    4: 'notUseful',
};
const DislikeForm = ({ lang, setFeedbackStatus, onShowFeedbackToast, feedbackTypes, isLoadingFeedbackTypes, feedbackTypesError, onSubmit, dislikeOption, userMessageNumber, amaConversationID, }) => {
    const [selectedTag, setSelectedTag] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    useEffect(() => {
        // Legacy: convert old dislikeOption to new format if needed
        if (dislikeOption && feedbackTypes) {
            const matchingOption = feedbackTypes.thumbsOptions.downs.find((opt) => opt.id === dislikeOption);
            if (matchingOption) {
                setSelectedTag(matchingOption);
            }
        }
    }, [dislikeOption, feedbackTypes]);
    const handleTagClick = (option) => {
        setSelectedTag(option);
    };
    const handleCancel = () => {
        setFeedbackStatus(undefined);
        setSelectedTag(null);
    };
    const handleSubmit = async () => {
        if (!selectedTag || !selectedTag.reason)
            return;
        setIsSubmitting(true);
        try {
            await onSubmit(selectedTag.id, selectedTag.reason);
            setFeedbackStatus('dislikeConfirmed');
            onShowFeedbackToast();
            trackEvent({ componentId: 'askMeAnything' }, {
                componentName: 'askMeAnything',
                componentState: 'dislikeFeedback',
                elementActioned: DISLIKE_REASON_TRACKING[selectedTag.id] ?? 'notUseful',
                elementAction: 'submited',
                elementActionValue: `message${userMessageNumber}`,
                amaConversationID: amaConversationID || 'noValue',
            });
        }
        catch (error) {
            console.error('Failed to submit feedback:', error);
            setFeedbackStatus('dislikeForm');
        }
        finally {
            setIsSubmitting(false);
        }
    };
    return (React.createElement(Card, { variant: "compact", sx: {
            marginTop: 'spaceS',
            boxShadow: 'boxShadowElevationS',
            borderRadius: 'radiusL2',
            borderWidth: 'size01',
            borderStyle: 'solid',
            borderColor: 'colorBorderSubdued',
        } },
        React.createElement(CardContent, { sx: { padding: 'spaceM' } },
            React.createElement(Flex, { flxDirection: "column", gap: "spaceM" },
                React.createElement(Text, { variant: "footnoteMedium", size: "small" }, labels[lang].dislikeFormTitle),
                isLoadingFeedbackTypes && (React.createElement(Stack, { direction: 'vertical' },
                    React.createElement(AiSpinner, { variant: "animated" }),
                    React.createElement(Text, { size: "small" }, labels[lang].feedbackLoadingMessage))),
                feedbackTypesError && (React.createElement(Text, { variant: "footnote", size: "small", sx: { color: 'colorTextCritical' } }, labels[lang].feedbackErrorMessage)),
                feedbackTypes && feedbackTypes.thumbsOptions.downs && (React.createElement(Flex, { gap: "spaceS", flxFlow: "row wrap" }, feedbackTypes.thumbsOptions.downs.map((option) => (React.createElement(Token, { key: option.id, size: "small", isSelected: selectedTag?.id === option.id, onClick: () => handleTagClick(option), label: labels[lang].dislikeFormOptions[option.id] ??
                        option.reason ??
                        '', sx: {
                        '>[data-genesis-element="ICON_CONTAINER"]': {
                            display: 'none',
                        },
                    } }))))),
                React.createElement(Flex, { gap: "spaceS", marginTop: "spaceS" },
                    React.createElement(Button, { variant: "secondary", size: "small", onClick: handleCancel, a11yLabel: labels[lang].dislikeFormCancel, isDisabled: isSubmitting, sx: { flex: 1 } }, labels[lang].dislikeFormCancel),
                    React.createElement(Button, { variant: "primary", size: "small", onClick: handleSubmit, isDisabled: !selectedTag || isSubmitting || isLoadingFeedbackTypes, a11yLabel: labels[lang].dislikeFormSubmit, sx: { flex: 1 } }, labels[lang].dislikeFormSubmit))))));
};
export default DislikeForm;
